/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-11-09",
    versionChannel: "nightly",
    buildDate: "2023-11-09T00:13:52.774Z",
    commitHash: "514611451fa6c56aa1394df3a70a690534469b40",
};
